class BlogColumns {
  constructor() {
    $(document).ready(() => {
      this.initialize();
    });
  }

  initialize() {
    this.columns = $('[data-blog-column]');
    this.scrollEl = $('[data-blog-scroll]');
    this.content = $('.article-content');
    this.articles = $('.blog-articles .blog-articles__article');
    this.article = $('article.article')
    this.canScroll = true;
    this.isMobile = window.innerWidth < 768;

    // add resize
    $(window).resize(() => {
      this.isMobile = window.innerWidth < 768;
    })

    this.setupEventListeners();
    this.formatContent();
    this.setReadingTimes();

    $(document).ready(() => {
      $('.grid').colcade({
        columns: '.grid-col',
        items: '.grid-item'
      })
    })
  }

  calculateReadingTime(content) {
    const text = content.text();
    const wpm = 225;
    const words = text.trim().split(/\s+/).length;
    const time = Math.ceil(words / wpm);
    return time;
  }

  setReadingTimes() {
    if(this.article) {
      const content = this.article.find('.article-content');
      const time = this.calculateReadingTime(content);
      this.article.find('[data-reading-time]').text(`${time} min`);
    }
    const _self = this;
    this.articles.each(function () {
      const content = $(this).find('.article-content');
      const time = _self.calculateReadingTime(content);
      $(this).find('[data-reading-time]').text(`${time} min`);
    })
  }

  formatContent() {
    if (!this.content) return;

    this.content.find('p:has(img)').addClass('article-image-container');
    this.content.find('img').each(function () {
      const width = $(this).width();
      const height = $(this).height();
      width > height ? $(this).parent().addClass('horizontal') : $(this).parent().addClass('vertical')
    })
  }

  setCanScroll(value) {
    this.canScroll = false;
  }

  setupEventListeners() {
    const _isMobile = this.isMobile;
    const handleScroll = this.handleScroll;
    const scrollColumns = this.scrollColumns.bind(this);
    const setCanScroll = this.setCanScroll.bind(this);

    $('.pal-wrapper').on('scroll', function () {
      const offset = $(this).scrollTop();
      if(_isMobile) {
        if (offset > 0) {
          setCanScroll(false);
          $('[data-blog-scroll]').css('overflow', 'hidden')
        } else {
          setCanScroll(true);
          $('[data-blog-scroll]').css('overflow', 'scroll')
        }
      } else {
        setCanScroll(false);
        $('[data-blog-scroll]').css('overflow', 'hidden')
      }
    })

    this.scrollEl.off('scroll', function () {
      handleScroll($(this), scrollColumns)
    });
    this.scrollEl.on('scroll', function () {
      handleScroll($(this), scrollColumns)
    });
  }

  handleScroll(el, cb) {
    const scrollTop = el.scrollTop();
    const scrollHeight = el.get(0).scrollHeight - $(window).height();
    const scrollPercent = scrollTop / scrollHeight;
    cb(scrollPercent, scrollTop)
  }

  scrollColumns(percent, scroll) {
    $('[data-blog-column]').each(function () {
      $(this).css('position', 'relative')
      const scrollHeight = $(this).get(0).scrollHeight - $(window).height();
      // $(this).css('top', `${(-1 * scrollHeight * percent + scroll)}px`)
      $(this).css('will-change', 'transform')
      $(this).css('transform', `translate3d(0px, ${(-1 * scrollHeight * percent + scroll)}px, 0px)`)
    })
  }
}

const blogColumns = new BlogColumns();